import * as React from "react"
import { cn } from "src/lib/utils"

const badgeVariants = (props) => {
  const baseClasses = "inline-flex items-center rounded-md border px-2.5 py-1 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"

  const variant = props.variant || "default"

  const variantClasses = {
    default: "border-transparent bg-walme-primary text-walme-bg hover:bg-walme-primary-hover",
    secondary: "border-transparent bg-walme-bg-elevated text-walme-text hover:bg-walme-bg-elevated-2",
    destructive: "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
    outline: "border-walme-border text-walme-text hover:bg-walme-bg-elevated",
    success: "border-transparent bg-success text-white hover:bg-success/80",
  }

  return cn(baseClasses, variantClasses[variant], props.className)
}

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={badgeVariants({ variant, className })} {...props} />);
}

export { Badge, badgeVariants }
